/* ============================================================
   BOOKSCART — Editorial Experience JS
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  var body = document.body;
  var cursorOn = body.hasAttribute('data-cursor-on');
  var motion = body.getAttribute('data-motion') || 'balanced';
  var motionMul = motion === 'subtle' ? 0.55 : (motion === 'dramatic' ? 1.6 : 1);

  /* ---------- Page load intro ---------- */
  function initIntro() {
    var intro = document.querySelector('[data-intro]');
    if (!intro) { document.body.classList.add('is-ready'); return; }
    if (reduce) { intro.classList.add('is-done'); document.body.classList.add('is-ready'); return; }
    window.addEventListener('load', function () {
      setTimeout(function () {
        intro.classList.add('is-done');
        document.body.classList.add('is-ready');
      }, 1500);
    });
    // Fallback if load takes too long
    setTimeout(function () { intro.classList.add('is-done'); document.body.classList.add('is-ready'); }, 3000);
  }

  /* ---------- Custom cursor ---------- */
  function initCursor() {
    if (!fine || reduce || !cursorOn) return;
    var dot = document.createElement('div'); dot.className = 'cursor';
    var ring = document.createElement('div'); ring.className = 'cursor-ring';
    document.body.appendChild(dot); document.body.appendChild(ring);
    document.documentElement.classList.add('has-cursor');
    var mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.left = mx + 'px'; dot.style.top = my + 'px';
    });
    (function loop() {
      rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18;
      ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
      requestAnimationFrame(loop);
    })();
    var hoverSel = 'a, button, [data-tilt], .book3d, .obook__stage, input, select, .profession, .explorer__tab, .finder__option';
    document.addEventListener('mouseover', function (e) {
      var t = e.target.closest(hoverSel);
      if (t) {
        dot.classList.add('cursor--hover'); ring.classList.add('cursor-ring--hover');
        var label = t.getAttribute('data-cursor');
        if (label) { ring.setAttribute('data-label', label); ring.classList.add('cursor-ring--label'); }
      }
    });
    document.addEventListener('mouseout', function (e) {
      var t = e.target.closest(hoverSel);
      if (t) { dot.classList.remove('cursor--hover'); ring.classList.remove('cursor-ring--hover', 'cursor-ring--label'); }
    });
  }

  /* ---------- Scroll-linked book opening ---------- */
  function initOpeningBook() {
    var book = document.querySelector('[data-obook]');
    if (!book) return;
    var stage = book.querySelector('.obook__stage');
    var hero = book.closest('.xhero') || book;
    var ajar = parseFloat(book.getAttribute('data-ajar'));
    if (isNaN(ajar)) ajar = 18;
    var sens = parseFloat(book.getAttribute('data-sensitivity')) || 22;
    function onScroll() {
      var r = hero.getBoundingClientRect();
      var vh = window.innerHeight;
      // progress 0..1 as hero scrolls through viewport
      var p = Math.min(Math.max((vh - r.top) / (vh + r.height), 0), 1);
      if (reduce) { stage.style.setProperty('--open', '-120deg'); return; }
      // start ajar, open up to -155deg based on sensitivity
      var open = -(ajar + Math.min(p * (sens / 10), 1) * (155 - ajar));
      var ry = -24 + p * 22;
      var rxTilt = 8 - p * 6;
      stage.style.setProperty('--open', open + 'deg');
      stage.style.transform = 'rotateX(' + rxTilt + 'deg) rotateY(' + ry + 'deg)';
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    // Mouse parallax on the stage
    if (fine && !reduce) {
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        stage.style.setProperty('--mx', x);
      });
    }
    onScroll();
  }

  /* ---------- Particles ---------- */
  function initParticles() {
    if (reduce) return;
    var host = document.querySelector('[data-particles]');
    if (!host) return;
    var base = parseInt(host.getAttribute('data-particles'), 10);
    if (isNaN(base) || base === 0) base = 26;
    var count = window.innerWidth < 700 ? Math.round(base * 0.5) : base;
    if (count <= 0) return;
    for (var i = 0; i < count; i++) {
      var p = document.createElement('span');
      p.className = 'particle';
      p.style.left = Math.random() * 100 + '%';
      p.style.top = (60 + Math.random() * 40) + '%';
      var s = 2 + Math.random() * 4;
      p.style.width = p.style.height = s + 'px';
      p.style.animationDuration = (6 + Math.random() * 8) + 's';
      p.style.animationDelay = (-Math.random() * 8) + 's';
      host.appendChild(p);
    }
  }

  /* ---------- Split hero title into lines/spans for kinetic reveal ---------- */
  function wrapHeroTitle() {
    var title = document.querySelector('[data-split]');
    if (!title) return;
    var lines = title.querySelectorAll('.ln');
    lines.forEach(function (ln) {
      if (ln.querySelector('span')) return;
      var span = document.createElement('span');
      span.innerHTML = ln.innerHTML;
      ln.innerHTML = '';
      ln.appendChild(span);
    });
  }

  /* ---------- Product page: drag-to-rotate book ---------- */
  function initPdpBook() {
    var wrap = document.querySelector('[data-pdp-book]');
    var stage = document.querySelector('[data-pdp-stage]');
    if (!wrap || !stage) return;
    var ry = -26, rx = 6, targetRy = -26, targetRx = 6, dragging = false, lastX = 0, lastY = 0, idle = true;

    function apply() {
      stage.style.transform = 'rotateX(' + rx + 'deg) rotateY(' + ry + 'deg)';
    }
    // gentle idle auto-rotate until user interacts
    (function loop() {
      if (idle && !reduce) { targetRy += 0.15; }
      ry += (targetRy - ry) * 0.12;
      rx += (targetRx - rx) * 0.12;
      apply();
      requestAnimationFrame(loop);
    })();

    function down(x, y) { dragging = true; idle = false; lastX = x; lastY = y; stage.classList.add('is-dragging'); }
    function move(x, y) {
      if (!dragging) return;
      targetRy += (x - lastX) * 0.4;
      targetRx = Math.max(-30, Math.min(30, targetRx - (y - lastY) * 0.3));
      lastX = x; lastY = y;
    }
    function up() { dragging = false; stage.classList.remove('is-dragging'); }

    wrap.addEventListener('mousedown', function (e) { down(e.clientX, e.clientY); });
    window.addEventListener('mousemove', function (e) { move(e.clientX, e.clientY); });
    window.addEventListener('mouseup', up);
    wrap.addEventListener('touchstart', function (e) { down(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
    wrap.addEventListener('touchmove', function (e) { move(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
    wrap.addEventListener('touchend', up);

    // Hover parallax when not dragging
    if (fine && !reduce) {
      wrap.addEventListener('mousemove', function (e) {
        if (dragging) return;
        var r = wrap.getBoundingClientRect();
        targetRy = -26 + ((e.clientX - r.left) / r.width - 0.5) * 30;
        targetRx = 6 - ((e.clientY - r.top) / r.height - 0.5) * 20;
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    wrapHeroTitle();
    initIntro();
    initCursor();
    initParticles();
    initPdpBook();
  });
})();
